module.exports = __webpack_public_path__ + "static/sanu-c047c50862dfbb17882933b66bb393f9.png";